import React, { useContext } from "react";
import { useFormContext } from "react-hook-form";
import { GenericFormContext } from "../../GenericFormContext";
import { Button } from "../../../Button";
import { Flex } from "../../../Flex";
import { ModalFooter } from "../../../Modal";
/**
 * FormModalFooter provides a footer space to put buttons or other actions
 * for a Modal form.
 */
export const FormModalFooter = ({ children }) => (React.createElement(ModalFooter, null,
    React.createElement(Flex, { width: "100%", justifyContent: "space-between", flexWrap: "wrap" }, children)));
/**
 * The default submit button will submit the form, and will disable itself if the
 * form is already submitting, or if the Modal form context indicates that editing
 * is not allowed.
 */
export const FormModalSubmitButton = ({ children }) => {
    const { formState } = useFormContext();
    const { editIsAllowed } = useContext(GenericFormContext);
    return (React.createElement(Button, { "data-testid": "submit", disabled: formState.isSubmitting || editIsAllowed === false, minWidth: "140px", px: "20px", py: "10px", type: "submit" }, children));
};
/**
 * The default cancel button will close the Modal without submitting the form.
 */
export const FormModalCancelButton = ({ children }) => {
    const { closeFormFn } = useContext(GenericFormContext);
    return (React.createElement(Button, { type: "button", variant: "secondary", "data-testid": "cancel", onClick: closeFormFn, minWidth: "140px", px: "20px", py: "10px" }, children));
};
